import { IState } from '../../../store';

export function selectIsLeadFactory(state: IState) {
  const offer = state.offerData.offer;

  return Boolean(offer.newbuilding && offer.newbuilding.isFromLeadFactory);
}
